import AddGenusSpecialityContainer from './AddGenusSpecialityContainer';
import AddGenusSpecialityService from './service/AddGenusSpeciality';
import stores from './stores';

const AddGenusSpeciality = {
    path:['/add-genus-specialty'],
    exact: true,
    services: [new AddGenusSpecialityService()],
    stores: stores,
    component: AddGenusSpecialityContainer,
};

export default AddGenusSpeciality